import { useState } from 'react';

import { cn } from '@/shared/utils';

import Button from '@/components/ui/button';
import SearchInput from '@/components/ui/searchInput';
import { Switch } from '@/components/ui/switch';

const FollowPlayers = ({ players, selected, onChange, onReset }) => {
  const [search, setSearch] = useState('');
  const [searchResult, setSearchResult] = useState([...players]);

  const handleSearch = (e) => {
    setSearch(e.target.value);
    setSearchResult(
      players.filter((player) =>
        player.name.toLowerCase().includes(e.target.value.toLowerCase())
      )
    );
  };

  const handleOnReset = () => {
    setSearch('');
    onReset();
  };

  return (
    <>
      <div className="flex items-center justify-between text-xl font-semibold text-secondary">
        Follow players
        <Button
          variant="link"
          disabled={selected.length === 0}
          onClick={handleOnReset}
        >
          Reset
        </Button>
      </div>
      <div>
        <SearchInput
          placeholder="Bowler name"
          inputClass="h-11 rounded-[10px]"
          value={search}
          onChange={handleSearch}
        />
      </div>
      <div className="space-y-1">
        {searchResult.length === 0 && (
          <section
            className={cn(
              'flex flex-col justify-center items-center',
              'p-5 mt-4 w-full bg-black/30 max-md:max-w-full',
              'h-60 gap-2 rounded-[10px]'
            )}
          >
            <h1 className="text-xl max-w-80 text-center font-bold">
              We couldn’t find <br /> bowlers with that name
            </h1>
            <p className="opacity-50 mb-6 text-center">
              Please check the search term and try again.
            </p>
          </section>
        )}
        {searchResult.map((player) => (
          <div
            key={player.id}
            className="flex items-center justify-between cursor-pointer border-b py-2 border-[#a1a1a166]"
            onClick={() => onChange(player.id)}
          >
            <div className="leading-[1.3]">
              <p className="font-semibold">{player.name}</p>
              <p className="text-secondary">Lane {player.lane}</p>
            </div>
            <Switch checked={selected.includes(player.id)} />
          </div>
        ))}
      </div>
    </>
  );
};

export default FollowPlayers;
